import { render, staticRenderFns } from "./ConfirmationCard.vue?vue&type=template&id=d477e702&scoped=true&"
import script from "./ConfirmationCard.vue?vue&type=script&lang=js&"
export * from "./ConfirmationCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationCard.vue?vue&type=style&index=0&id=d477e702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d477e702",
  null
  
)

export default component.exports